import DataTableView from "@components/views/datatable-view";
import { useHealthScore } from "./use-health-score";
import { useTranslation } from "react-i18next";

const HealthScore = () => {
    const {
        loading,
        data: { healthScores, globalHealthScore },
        columns
    } = useHealthScore();
    const { t } = useTranslation();
    return (
        <>
            <DataTableView
                className="mt-2"
                moduleName="Health Scores"
                desc={globalHealthScore ? t("Global Health Score: {{globalHealthScore}}", { globalHealthScore }) : ""}
                tableProps={{
                    data: healthScores,
                    columns
                }}
                loading={loading}/>
        </>
    );
};

export default HealthScore;
